<h2 mat-dialog-title *ngIf="dialogData?.showAttachmentSourceCode">
  {{ attachmentDocName ? attachmentDocName : "Attachment Source Code" }}
</h2>

<mat-dialog-content
  class="draftDialogContent"
  style="height: calc(100% - 59px); max-height: none"
  id="draft-main"
  *ngIf="!dialogData?.showAttachmentSourceCode"
>
  <div class="draft-page h-100">
    <mat-stepper
      linear
      #stepper
      *ngIf="formId && this?.caseDetails?.appTypeId; else defaultDraftView"
    >
      <!--Step1 Fill Form-->
      <mat-step
        label="Fill Form"
        [completed]="isCompleted"
        [editable]="formCheck"
        [stepControl]="draftAppgenFormGroup"
      >
        <div class="form-gen h-100">
          <ng-template
            [componentLoader]="'AppGenComponent'"
            [componentInputs]="componentInputs"
            [componentOutputs]="componentOutputs"
            (output)="outputFromAppGen($event)"
          >
          </ng-template>
        </div>
      </mat-step>

      <!--Step2 Configure Draft -->
      <mat-step label="Create Draft" state="create" id="stepper2">
        <ng-container *ngTemplateOutlet="draftView"></ng-container>
      </mat-step>
      <!-- Icon overrides. -->
      <ng-template matStepperIcon="formGen">
        <mat-icon>edit</mat-icon>
      </ng-template>
      <ng-template matStepperIcon="create">
        <mat-icon>notifications</mat-icon>
      </ng-template>
    </mat-stepper>
    <ng-template #defaultDraftView>
      <ng-container *ngTemplateOutlet="draftView"></ng-container>
    </ng-template>
  </div>
</mat-dialog-content>

<!-- ADDED CONETENT FOR ATTACHMENT SOURCE CODE VIEW -->
<mat-dialog-content *ngIf="dialogData?.showAttachmentSourceCode">
  <mat-icon
    color="primary"
    class="copyFile"
    matTooltip="Save to ClipBoard"
    (click)="saveToClipboard()"
    >file_copy</mat-icon
  >
  <ckeditor
    [data]="attachmentSourceData"
    [config]="readOnlyEditorConfig"
    [editorUrl]="ckEditorUrl"
  >
  </ckeditor>
</mat-dialog-content>
<!-- ADDED ACTION BUTTON FOR ATTACHMENT SOURCE CODE VIEW -->
<mat-dialog-actions
  class="action-btn"
  align="end"
  *ngIf="dialogData?.showAttachmentSourceCode"
>
  <button color="primary" mat-dialog-close mat-raised-button>Close</button>
</mat-dialog-actions>
<mat-dialog-actions
  class="action-btn"
  align="end"
  *ngIf="!dialogData?.showAttachmentSourceCode"
>
  <div
    *ngIf="
      stepper?.selectedIndex == 0 && this.formId && this?.caseDetails?.appTypeId
    "
  >
    <button
      class="create-button"
      mat-button
      (click)="onNext()"
      [disabled]="!draftAppgenFormGroup?.controls?.isValid?.value"
    >
      <mat-icon class="create-icons">arrow_right_alt</mat-icon>Next
    </button>

    <button mat-raised-button mat-dialog-close>Cancel</button>
  </div>
  <div
    *ngIf="
      this.formId && this?.caseDetails?.appTypeId
        ? stepper?.selectedIndex == 1
        : true
    "
  >
    <button
      color="primary"
      (click)="save('').subscribe()"
      style="margin-right: 5px"
      mat-raised-button
      [disabled]="!draftForm.valid"
      *ngIf="
        !onlyPreview &&
        !dialogData?.flag &&
        !fromSaveAndPublish &&
        this.showSaveBtn &&
        !dialogData?.readonly
      "
    >
      Save
    </button>
    <button
      color="primary"
      (click)="save('save&close').subscribe()"
      style="margin-right: 5px"
      mat-raised-button
      [disabled]="!draftForm.valid"
      *ngIf="
        !onlyPreview &&
        !dialogData?.flag &&
        !fromSaveAndPublish &&
        this.showSaveAndCloseBtn &&
        !dialogData?.readonly
      "
    >
      Save & Close
    </button>
    <button
      color="primary"
      (click)="preview()"
      style="margin-right: 5px"
      mat-raised-button
      [disabled]="showAttachmentFlag || from == 'prepare'"
      *ngIf="
        !onlyPreview &&
        !dialogData?.flag &&
        !fromSaveAndPublish &&
        this.showPreviewBtn &&
        !dialogData?.readonly
      "
    >
      Preview
    </button>
    <button
      color="primary"
      (click)="approve()"
      style="margin-right: 5px"
      mat-raised-button
      [disabled]="from == 'prepare'"
      *ngIf="
        !onlyPreview &&
        !dialogData?.flag &&
        !fromSaveAndPublish &&
        this.showApproveBtn &&
        !dialogData?.readonly &&
        isApprover
      "
    >
      Approve
    </button>

    <button
      color="primary"
      (click)="saveAndPrintDraft()"
      style="margin-right: 5px"
      mat-raised-button
      *ngIf="
        !onlyPreview &&
        !dialogData?.flag &&
        !fromSaveAndPublish &&
        this.showSaveAndPublishBtn
      "
    >
      {{
        this.dialogData?.selectedDraft?.publishMode != 4
          ? "Save & Publish"
          : "Save & Approve"
      }}
    </button>

    <button
      color="primary"
      style="margin-right: 5px"
      mat-raised-button
      *ngIf="dialogData?.flag && dialogData?.showSubmit"
    >
      Submit
    </button>
    <button
      color="primary"
      (click)="onPublish()"
      style="margin-right: 5px"
      mat-raised-button
      *ngIf="
        isDraftApproved &&
        this.dialogData?.selectedDraft?.publishMode != 4 &&
        !fromSaveAndPublish
      "
    >
      Publish
    </button>
    <button
      color="primary"
      (click)="createVersionOfDraft()"
      style="margin-right: 5px"
      mat-raised-button
      *ngIf="isDraftApproved && !dialogData?.flag && !fromSaveAndPublish"
    >
      Create New Version of Draft
    </button>
    <button mat-flat-button (click)="cancel()">Close</button>
  </div>
</mat-dialog-actions>

<ng-template #draftView
  ><div class="h-100">
    <div *ngIf="!showAttachmentFlag" class="draft-template h-100">
      <h2
        style="margin-bottom: 5px"
        mat-dialog-title
        *ngIf="!showAttachmentFlag"
      >
        {{ dialogData?.title ? dialogData?.title : "Edit Draft" }}
      </h2>
      <div class="mat-typography maxHeight" *ngIf="!showAttachmentFlag">
        <div *ngIf="!dialogData?.flag">
          <form [formGroup]="draftForm">
            <div class="row">
              <div class="col-sm-4">
                <mat-form-field>
                  <mat-label translate class="required-field">
                    Title
                  </mat-label>
                  <input sanitized
                    [readOnly]="readOnlyCkeditor"
                    [(ngModel)]="draftTitle"
                    name="draftTitle"
                    formControlName="draftTitle"
                    (input)="onTitleChange()"
                    [maxlength]="maxChars"
                    matInput
                  />
                  <mat-error>{{
                    "create_draft.draftTitle_Error" | translate
                  }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-8">
                <mat-slide-toggle
                  class="pt-4"
                  [(ngModel)]="officeEnabled"
                  name="officeEnabled"
                  formControlName="officeEnabled"
                  >OnlyOffice Enabled</mat-slide-toggle
                >
              </div>
            </div>
          </form>
        </div>
        <div class="my-2">
          <strong
            >Note : It is necessary to hold the Ctrl key when right-clicking
            misspelled words to see their suggestions.</strong
          >
        </div>
        <div style="min-height: 400px">
          <ckeditor
            #editor
            *ngIf="
              (this.formId && this?.caseDetails?.appTypeId
                ? stepper?.selectedIndex == 1
                : true) &&
              showEditor &&
              pageRendered &&
              showCkEditor
            "
            [readOnly]="readOnlyCkeditor"
            [formControl]="data"
            [config]="editorConfig"
            (ready)="onEditorReady($event)"
            (change)="onChange($event)"
            [editorUrl]="ckEditorUrl"
          >
          </ckeditor>
        </div>
      </div>
    </div>
    <div *ngIf="showAttachmentFlag" class="maxHeight">
      <h2 mat-dialog-title *ngIf="!onlyPreview">Preview Draft</h2>
      <h2 mat-dialog-title *ngIf="onlyPreview">{{ draftTitle }}</h2>
      <div class="mat-typography maxHeight">
        <div>
          <button
            (click)="closeAttachment()"
            class="float-end"
            mat-icon-button
            color="primary"
            type="button"
            *ngIf="!onlyPreview"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="h-100" *ngIf="previewSrc">
          <img
            *ngIf="currentType == 'image'"
            [src]="previewSrc"
            width="100%"
            [height]="height"
          />
          <iframe
            *ngIf="currentType == 'pdf'"
            [src]="previewSrc"
            width="100%"
            [height]="height"
            title="'hello'"
          >
          </iframe>
        </div>
      </div>
    </div></div
></ng-template>
